import { render, staticRenderFns } from "./CustomerShippingAddressSelect.vue?vue&type=template&id=180014f4&scoped=true"
import script from "./CustomerShippingAddressSelect.vue?vue&type=script&lang=js"
export * from "./CustomerShippingAddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180014f4",
  null
  
)

export default component.exports